const groupsByType = {
  nps: ['promoters', 'passives', 'detractors'],
  ces: ['agree', 'neutral', 'disagree'],
  csat: ['satisfied', 'neutral', 'dissatisfied'],
  star_five: Array(5)
    .fill(0)
    .map((a, i) => `${5 - i}-stars`),
};

export default groupsByType;
